import { render, staticRenderFns } from "./ModalLogs.vue?vue&type=template&id=06a551be"
import script from "./ModalLogs.vue?vue&type=script&lang=js"
export * from "./ModalLogs.vue?vue&type=script&lang=js"
import style0 from "./ModalLogs.vue?vue&type=style&index=0&id=06a551be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports